import { Check, Sparkles } from 'lucide-react';
import { PaymentPlan } from '../types';

export function formatPrice(amount: number, currency: string): string {
  return `${amount.toLocaleString('fr-FR')} ${currency === 'USD' ? '$' : 'FC'}`;
}

/**
 * Lignes d'avantages DÉRIVÉES des entitlements du plan : ce qui est affiché
 * est exactement ce que le QuotaGate applique — plus jamais de texte
 * marketing déconnecté du comportement réel.
 */
export function entitlementLines(plan: PaymentPlan): string[] {
  const e = plan.entitlements;
  return [
    e.dailyPracticeLimit === null
      ? 'Sessions de pratique illimitées'
      : `${e.dailyPracticeLimit} session${e.dailyPracticeLimit > 1 ? 's' : ''} de pratique par jour`,
    e.dailySimulationLimit === null
      ? 'Simulations complètes illimitées'
      : `${e.dailySimulationLimit} simulation${e.dailySimulationLimit > 1 ? 's' : ''} complète${e.dailySimulationLimit > 1 ? 's' : ''} par jour`,
  ];
}

interface PlanCardProps {
  plan: PaymentPlan;
  /** Plan de l'abonnement actuel de l'utilisateur. */
  isCurrent?: boolean;
  onSelect: (plan: PaymentPlan) => void;
  disabled?: boolean;
}

export function PlanCard({ plan, isCurrent, onSelect, disabled }: PlanCardProps) {
  return (
    <div
      className={`relative flex flex-col bg-overlay-1 border rounded-2xl p-6 transition-all ${
        plan.highlighted
          ? 'border-green-500/50 shadow-lg shadow-green-500/10'
          : 'border-line'
      }`}
    >
      {plan.highlighted && (
        <span className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1 px-3 py-1 bg-gradient-to-r from-green-500 to-emerald-600 text-white text-[10px] font-bold uppercase tracking-wider rounded-full">
          <Sparkles className="w-3 h-3" /> Populaire
        </span>
      )}

      <h3 className="text-lg font-bold text-fg">{plan.name}</h3>
      <p className="text-xs text-fg-subtle mt-1 mb-4">{plan.description}</p>

      <div className="mb-5">
        <span className="text-3xl font-extrabold text-fg">
          {formatPrice(plan.price, plan.currency)}
        </span>
        <span className="text-sm text-fg-faint"> / mois</span>
      </div>

      <ul className="space-y-2.5 mb-6 flex-1">
        {[...entitlementLines(plan), ...plan.features].map((feature) => (
          <li key={feature} className="flex items-start gap-2 text-sm text-fg-muted">
            <Check className="w-4 h-4 text-green-400 flex-shrink-0 mt-0.5" />
            {feature}
          </li>
        ))}
      </ul>

      <button
        onClick={() => onSelect(plan)}
        disabled={disabled || isCurrent}
        className={`w-full py-3 rounded-xl text-sm font-semibold transition-all active:scale-[0.98] disabled:opacity-60 ${
          plan.highlighted
            ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white'
            : 'bg-overlay-2 border border-line text-fg hover:bg-overlay-2/70'
        }`}
      >
        {isCurrent ? 'Plan actuel' : 'Choisir ce plan'}
      </button>
    </div>
  );
}
